import { motion } from "framer-motion";
import { FileText, Search, CheckCircle2, Banknote } from "lucide-react";

const steps = [
  {
    n: "01",
    icon: FileText,
    title: "Apply in 2 minutes",
    desc: "Fill out a short online application. No paperwork, no credit pull, no obligation.",
  },
  {
    n: "02",
    icon: Search,
    title: "We match your options",
    desc: "Our team reviews your business profile and matches you with the best-fit funding products.",
  },
  {
    n: "03",
    icon: CheckCircle2,
    title: "Fast approval",
    desc: "Get decisioned by real underwriters — most approvals happen within a few hours.",
  },
  {
    n: "04",
    icon: Banknote,
    title: "Money in your account",
    desc: "Sign digitally and receive funds — in many cases within 24 hours of approval.",
  },
];

export default function HowWeWork() {
  return (
    <section
      id="how-we-work"
      data-testid="how-we-work-section"
      className="py-24 md:py-32 bg-white relative"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <span className="text-xs font-bold uppercase tracking-[0.25em] text-purple-600">
            How we work
          </span>
          <h2 className="font-display text-4xl md:text-5xl lg:text-6xl font-black mt-3 tracking-tight text-slate-900">
            Funding in 4 simple steps.
          </h2>
          <p className="mt-5 text-lg text-slate-500">
            No hidden fees, no bank runaround. A modern process built for busy
            operators.
          </p>
        </div>

        <div className="relative grid grid-cols-1 md:grid-cols-4 gap-6 md:gap-8">
          {/* connecting line */}
          <div className="hidden md:block absolute top-16 left-[12%] right-[12%] h-0.5 bg-gradient-to-r from-purple-200 via-purple-400 to-purple-200" />

          {steps.map((s, idx) => (
            <motion.div
              key={s.n}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: idx * 0.1 }}
              className="relative"
              data-testid={`how-step-${s.n}`}
            >
              <div className="relative z-10 w-16 h-16 mx-auto rounded-2xl bg-gradient-to-br from-purple-500 to-fuchsia-600 grid place-items-center shadow-lg shadow-purple-500/30">
                <s.icon className="w-7 h-7 text-white" />
              </div>
              <div className="mt-6 text-center">
                <div className="font-display text-xs font-bold text-purple-600 tracking-widest">
                  STEP {s.n}
                </div>
                <h3 className="font-display text-xl md:text-2xl font-bold mt-2 text-slate-900">
                  {s.title}
                </h3>
                <p className="mt-3 text-sm text-slate-500 leading-relaxed">
                  {s.desc}
                </p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
